// Contenedores de los slots de Promociones en las filas y al pie; sin slot no pintan nada.
import type { SaleLine } from '@/api/services/retail-wizard/contract';
import { cn } from '@/lib/cn';
import type { LinePromotionSlot, SaleBenefitsSlot, SlotSale } from './saleSlots';

export function LinePromotionOutlet({
    slot,
    line,
    sale,
    className,
}: {
    slot: LinePromotionSlot | undefined;
    line: SaleLine;
    sale: SlotSale;
    className?: string;
}) {
    if (!slot) return null;
    return (
        <div data-testid="sale-line-promotion" className={cn('empty:hidden', className)}>
            {slot(line, sale)}
        </div>
    );
}

export function SaleBenefitsOutlet({
    slot,
    sale,
    className,
}: {
    slot: SaleBenefitsSlot | undefined;
    sale: SlotSale;
    className?: string;
}) {
    if (!slot) return null;
    return (
        <div data-testid="sale-benefits" className={cn('empty:hidden', className)}>
            {slot(sale)}
        </div>
    );
}
